/**
 * Пороги Score (ТЗ, раздел 7.2).
 *
 * Предикат живёт в контрактах, а не в терминале, намеренно. По ТЗ
 * пороги — пользовательская настройка, и на этапе 06 фильтрация
 * переедет в Core, ближе к профилю пользователя. Чтобы при переезде
 * «видимый набор сигналов» не разъехался между сервером и терминалом,
 * решение принимает одна и та же функция.
 *
 * Важно, чего фильтр НЕ делает: он не удаляет сигналы. В базу пишутся
 * все, включая отсеянные (ТЗ, раздел 6.1) — иначе потом нечем обосновать
 * выбор порога и невозможно посчитать статистику бота.
 */
export const DEFAULT_THRESHOLDS = { long: 70, short: 70 };
/**
 * Порог по стороне сигнала.
 *
 * У события без направления стороны нет, а значит нет и порога: скрыть
 * уведомление «RSI упал ниже тридцати» по порогу для длинных было бы
 * бессмыслицей. Такие сигналы проходят всегда.
 */
export function thresholdFor(thresholds, side) {
    if (side === 'ALERT')
        return 0;
    return side === 'LONG' ? thresholds.long : thresholds.short;
}
export function passesThreshold(signal, thresholds) {
    return signal.score >= thresholdFor(thresholds, signal.side);
}
/*
 * BelowThresholdMode объявлен в settings.ts: он часть профиля
 * пользователя, а не свойство порога как такового.
 */
/**
 * Градации Score для оформления маркера (ТЗ, раздел 6.3).
 *
 * Score — единственный численный интерфейс качества сигнала, и его
 * семантику задаёт бот. Терминал лишь переводит число в заметность.
 *
 * Слабый маркер приглушён, но остаётся видимым, и нижняя граница здесь
 * важнее самой градации. Раньше слабый рисовался на четыре десятых —
 * и красная стрелка поверх красной полосы «Выгодных зон» исчезала
 * начисто. Человек получал уведомление в Telegram, шёл на график и не
 * находил там ничего: ни стрелки, ни объяснения, куда она делась.
 *
 * Сигнал, которым разбудили, обязан быть виден. Насколько он силён,
 * говорят и число рядом, и размер метки; прятать его ради этого не
 * нужно.
 */
export function markerOpacity(score) {
    if (score >= 75)
        return 1;
    if (score >= 60)
        return 0.9;
    return 0.75;
}
/** Score, при котором маркер получает подсветку. */
export const SCORE_STRONG = 90;
//# sourceMappingURL=threshold.js.map